export default __webpack_public_path__ + "static/media/y.dfb92f72.svg";